module.exports = __webpack_public_path__ + "img/scratch_cards_rear.22d0c1ed.jpg";